import { render, staticRenderFns } from "./beirunUserWeChat.vue?vue&type=template&id=315e5856&scoped=true&"
import script from "./beirunUserWeChat.vue?vue&type=script&lang=js&"
export * from "./beirunUserWeChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e5856",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315e5856')) {
      api.createRecord('315e5856', component.options)
    } else {
      api.reload('315e5856', component.options)
    }
    module.hot.accept("./beirunUserWeChat.vue?vue&type=template&id=315e5856&scoped=true&", function () {
      api.rerender('315e5856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/beirunUserWeChat/beirunUserWeChat.vue"
export default component.exports